import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { Button, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import { formatDateTimeLocalDate } from '../../../utilities/Utils'
import { FaEye, FaPaperPlane, FaPrint } from 'react-icons/fa'
import ModalProsesNonLalin from '../modal/ModalProsesNonLalin'
import ModalSppNonLalin from '../modal/ModalSppNonLalin'
import ModalCetakNonLalin from '../modal/ModalCetakNonLalin'
import ModalBast from '../modal/ModalBast'
import ModalLhpNonLalin from '../modal/ModalLhpNonLalin'
import ModalPnbpNonLalinV2 from '../modal/ModalPnbpNonLalinV2'

const ExpandableComponentNonLalin = ({ data, reloadList }) => {
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const _resDispo = await nonLalinService.listNonlalinPenugasanAll(data.nomorAju)
                setListDisposisi(_resDispo.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [nonLalinService, data])


    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><NonlalinDisposisi idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.createdAt)}</small>
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses datappm={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ datappm, dataPenugasan, reloadList }) => {
    // console.log(dataPenugasan)
    const [dataDisposisi, setDataDisposisi] = useState({})

    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)

    const [showAddProses, setShowAddProses] = useState(false)
    const handleCloseAddProses = () => setShowAddProses(false)
    const [showAddPenugasan, setShowAddPenugasan] = useState(false);
    const handleCloseAddPenugasan = () => setShowAddPenugasan(false);
    const [showAddBast, setShowAddBast] = useState(false);
    const handleCloseAddBast = () => setShowAddBast(false);
    const [showAddLhp, setShowAddLhp] = useState(false);
    const handleCloseAddLhp = () => setShowAddLhp(false);
    const [showAddPnbp, setShowAddPnbp] = useState(false)
    const handleCloseAddPnbp = () => setShowAddPnbp(false)

    const [isEdit, setIsEdit] = useState(false)

    const handleShowAdd = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            setShowAddProses(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setShowAddPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            //bast
            setShowAddBast(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            //lhp
            setShowAddLhp(true)
        } else if (dataPenugasan.idDisposisi === 5) {
            //pnbp
            setIsEdit(true)
            setShowAddPnbp(true)
        }
    }

    const handleShowView = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            // setShowViewProses(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            //sp lab
            // setShowViewPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            //bast
            // setShowViewLapEv(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            //lhp
            // setShowViewLapVerLap(true)
        } else if (dataPenugasan.idDisposisi === 5){
            setIsEdit(false)
            setShowAddPnbp(true)
        }
    }

    const handleClickCetak = (dataPenugasan) => {
        // console.log('cetak')
        setDataDisposisi(dataPenugasan)
        setShowCetak(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-4">
                    {
                        ((localStorage.getItem("role") !== '4' && localStorage.getItem("role") !== '5' && localStorage.getItem("role") !== '8') && dataPenugasan.noTugas === null) &&
                        // (dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShowAdd(dataPenugasan)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.idDisposisi !== 4 && dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShowView(dataPenugasan)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {(dataPenugasan.idDisposisi !== 1 && dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning" onClick={() => handleClickCetak(dataPenugasan)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalProsesNonLalin showAddProses={showAddProses} handleCloseAddProses={handleCloseAddProses} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalSppNonLalin showAddPenugasan={showAddPenugasan} handleCloseAddPenugasan={handleCloseAddPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalBast showAddBast={showAddBast} handleCloseAddBast={handleCloseAddBast} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalLhpNonLalin showAddLhp={showAddLhp} handleCloseAddLhp={handleCloseAddLhp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalPnbpNonLalinV2 showAddPnbp={showAddPnbp} handleCloseAddPnbp={handleCloseAddPnbp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isEdit={isEdit}/>
            <ModalCetakNonLalin showCetak={showCetak} handleCloseCetak={handleCloseCetak} dataDisposisi={dataDisposisi} datappm={datappm} />
        </>
    )
}

export default ExpandableComponentNonLalin